import { Col, Divider, FormLabel, Row, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

interface OrganizationContractSettingFormColumnLabelsProps {
    isEditing: boolean;
}

export function OrganizationContractSettingFormColumnLabels(
    props: Readonly<OrganizationContractSettingFormColumnLabelsProps>
) {
    const translate = getSelectedLanguage();

    return (
        <Row>
            <Col span={3}></Col>
            <Col span={3}>
                <FormLabel
                    tooltipText={props.isEditing ? translate.contractSettings.startDateIsFirstDayOfMonth : undefined}
                >
                    {translate.common.startingDate}
                </FormLabel>
            </Col>
            <Col span={3}>
                <FormLabel
                    tooltipText={props.isEditing ? translate.contractSettings.endDateIsLastDayOfMonth : undefined}
                >
                    {translate.common.endDate}
                </FormLabel>
            </Col>
            <Col span={3}>
                <Text>{translate.contractSettings.priceAgreement}</Text>
            </Col>
            <Divider spacing="small" />
        </Row>
    );
}
